// extracted by mini-css-extract-plugin
module.exports = {"container":"ChallengeJoinButton--container--1hwe0","button":"ChallengeJoinButton--button--2vgnp"};